import { render, staticRenderFns } from "./Campaign.smartlinks.vue?vue&type=template&id=85a08ad0&scoped=true&lang=html&"
import script from "./Campaign.smartlinks.vue?vue&type=script&lang=js&"
export * from "./Campaign.smartlinks.vue?vue&type=script&lang=js&"
import style0 from "./Campaign.smartlinks.vue?vue&type=style&index=0&id=85a08ad0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a08ad0",
  null
  
)

export default component.exports